import Vue from 'vue'
import commonMutations from '@/store/ui/common/mutations'
import { isEqual, findIndex } from 'lodash'

const mutations = {
    ...commonMutations,
    // transfer from now in audience builder + audience monitoring
    setTransferForm(state, { action, techno, transfer }) {
        if (action === 'add') {
            const index = state.forms[techno].length
            Vue.set(state.forms[techno], index, transfer)
        } else if (action === 'remove') {
            const indexOfItemToRemove = findIndex(state.forms[techno], form => isEqual(form, transfer))
            Vue.delete(state.forms[techno], indexOfItemToRemove)
        }
    },
    setErrorsForTransferForm(state, list) {
        if(list.length > 0) {
            list.forEach(transfer => {
                const techno = transfer.pixel_url !== '' ? 'technology-pixel' : 'technology-media'
                state.forms[techno].forEach(form => {
                    if (form.label.toLowerCase() === transfer.label.toLowerCase()) form.errors = transfer?.result_errors
                })
            })
        } else {
            state.forms['technology-pixel'].forEach(form => {
                if (form.errors) delete form.errors
            })
            state.forms['technology-media'].forEach(form => {
                if (form.errors) delete form.errors
            })
        }
        Vue.set(state, 'forms', state.forms)
    },
    setShowFormTransfer(state, { show }) {
        Vue.set(state, 'showFormTransfer', show)
    },
    setShowFormCreateTransfer(state, { show }) {
        Vue.set(state, 'showFormCreateTransfer', show)
    },
    setIsEditTransfer(state, { isEdit }) {
        Vue.set(state, 'isEdit', isEdit)
    },
    setTransferInEdition(state, { transfer }) {
        Vue.set(state, 'transferInEdition', transfer)
    },
    setDefaultTransferForm(state) {
        Vue.set(state, 'forms', {
            'technology-media': [],
            'technology-pixel': []
        })
        Vue.set(state, 'showFormTransfer', false)
        Vue.set(state, 'showFormCreateTransfer', false)
        Vue.set(state, 'transferInEdition', {})
        Vue.set(state, 'isEdit', false)
    },
    setTransferEndDate(state, { endDate }) {
        Vue.set(state, 'endDate', endDate)
    },
    setActiveTransfers(state, { activeTransfers }) {
        Vue.set(state, 'activeTransfers', activeTransfers)
    },
    setSelectedTransferRowId(state, id) {
        state.selectedTransferRowId = id
    },
    setDeletedTransfer(state, deletedTransfer ) {
        state.deletedTransfer = deletedTransfer
    },
}

export default mutations
